import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { Tags } from "@/enum/tags";
import { apiSlice, refreshAccessToken } from "@/services/http";

const RECONCILE_TAGS: Tags[] = [Tags.USER, Tags.OPTIONS_STORE];

export function useReconcile(): () => Promise<boolean> {
  const dispatch = useDispatch();

  return useCallback(async () => {
    const refreshed = await refreshAccessToken(dispatch);
    if (refreshed) {
      dispatch(apiSlice.util.invalidateTags(RECONCILE_TAGS));
    }
    return refreshed;
  }, [dispatch]);
}
